import * as types from "../actions/types";

const initial = {
  notification_list: [],
  per_page: 8,
};

const notifReducer = (state = initial, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_NOTIF:
      return { ...state, notification_list: payload };
    default:
      return state;
  }
};

export default notifReducer;
